module.exports = __webpack_public_path__ + "static/passport-2-06aecf624af6b172356ace1a8014601a.svg";